<template>
    <app-content>
        <app-content-body>
            <div class="inner">
                <p class="buttons">
                    <a
                        class="btn btn_action btn_add"
                        :title="translations.addNewImageSize"
                        @click.prevent="createItem"
                    ></a>
                </p>
                <h1 v-translate>Rozměry obrázků</h1>
            </div>

            <app-table
                clickable
                deletable
                highlight-rows-on-hover
                :data="items"
                :order="params.order"
                :page-size="params.limit"
                :loading="listLoading"
                @sort="sortItems"
                @rowClick="goToDetail"
                @deleteRow="deleteItem"
            >
                <app-table-column first sortable attribute="name" :label="translations.name">
                    <template slot-scope="row">
                        <strong>
                          {{ row.name }}
                        </strong>
                    </template>
                </app-table-column>
                <app-table-column first sortable attribute="code" :label="translations.code">
                    <template slot-scope="row">
                        {{ row.code }}
                    </template>
                </app-table-column>
                <app-table-column first sortable attribute="width" :label="translations.width">
                    <template slot-scope="row">
                        {{ row.width }}
                    </template>
                </app-table-column>
                <app-table-column first sortable attribute="height" :label="translations.height">
                    <template slot-scope="row">
                        {{ row.height }}
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="enabled" :label="translations.enabled">
                    <template slot-scope="row">
                        <app-graphic-image
                            :value="row.enabled"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="logo" :label="translations.logo">
                    <template slot-scope="row">
                        <app-graphic-image
                                :value="row.logo"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="thumbnail" :label="translations.thumbnail">
                    <template slot-scope="row">
                        <app-graphic-image
                                :value="row.thumbnail"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="poster" :label="translations.poster">
                    <template slot-scope="row">
                        <app-graphic-image
                                :value="row.poster"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="isDeviceSize" :label="translations.isDeviceSize">
                    <template slot-scope="row">
                        <app-graphic-image
                            :value="row.isDeviceSize"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="dateCreated" :label="translations.created">
                    <template slot-scope="row">
                        <div v-html="formatDate(row._created)" />
                    </template>
                </app-table-column>
            </app-table>
        </app-content-body>
    </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'ImageSizes',
  enumsMap: true
})

export default {
  name: 'image-sizes',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  computed: {
    translations() {
      return {
        addNewImageSize: this.$gettext('Přidat rozměr obrázku'),
        name: this.$gettext('Název'),
        code: this.$gettext('Kód'),
        width: this.$gettext('Šířka'),
        height: this.$gettext('Výška'),
        enabled: this.$gettext('Povoleno'),
        logo: this.$gettext('Logo'),
        thumbnail: this.$gettext('Thumbnail'),
        poster: this.$gettext('Poster'),
        isDeviceSize: this.$gettext('Device'),
        created: this.$gettext('Založeno'),
      }
    },
    currentTitle() {
      return [
        this.$gettext('Rozměry obrázků')
      ]
    }
  }
}
</script>
